module.exports = __webpack_public_path__ + "static/indianViolin-9e191fbaa613e3c8119e0e528ca9db35.mp3";